// GLobal
import { tv } from 'tailwind-variants';
import { JSX } from 'react';

// Local
import { SiteStructure } from '.generated/Feature.CW.model';
import { withStandardComponentWrapper } from 'helpers/HOC';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { ComponentProps } from 'lib/component-props';
import { useRouter } from 'next/router';

export type LegalInfoProps = ComponentProps & SiteStructure.Footer.LegalInfo_Component;

const LegalInfo = (props: LegalInfoProps): JSX.Element => {
  const { copyrightText } = props?.fields || {};
  const { RenderingIdentifier } = props?.params || {};
  const router = useRouter();
  // Detect private mode
  const isPrivateMode = router?.query?.private === 'true';

  /*
   * Rendering
   */

  if (!props?.fields) {
    return <></>;
  }

  const extendedTailwindVariants = tv({
    extend: TAILWIND_VARIANTS,
    slots: {
      base: [props?.params?.styles],
    },
  });

  const { base, textWrapper, wrapper } = extendedTailwindVariants();

  return !isPrivateMode ? (
    <div
      className={base()}
      data-component="authorable/shared/site-structure/footer/legalinfo"
      id={RenderingIdentifier}
    >
      <div className={wrapper()}>
        <RichTextWrapper className={textWrapper()} field={copyrightText} tag="div" />
      </div>
    </div>
  ) : (
    <></>
  );
};
export const Default = withStandardComponentWrapper(LegalInfo);

const TAILWIND_VARIANTS = tv({
  slots: {
    base: ['py-12', 'lg:py-6', 'bg-blue-100'],
    textWrapper: ['text-14 font-normal text-gray-900 font-centuryGothic'],
    wrapper: ['max-w-screen-xxl', 'm-auto', 'px-10', 'lg:px-20'],
  },
});
